/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { MyButton } from "../../component/Component";
import { useStaticContext } from "../../../../context/static/StaticContext";
import { pushOneAiChatInfo } from "../../../../middlewares/sysNavigation/SysNavigation";

const editRoute = "/ai_chat_info/edit";

const Overview = () => {
  const [aiChatInfoList, setAiChatInfoList] = useState([]);
  const { aiChatInfo, fetchAiChatInfo } = useStaticContext();

  useEffect(() => {
    if (!aiChatInfo) fetchAiChatInfo();
    else setAiChatInfoList(aiChatInfo);
  }, [aiChatInfo]);

  const hasData = Array.isArray(aiChatInfoList) && aiChatInfoList.length > 0;

  return (
    <div className="p-3 lg:p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <div className="mx-auto w-full max-w-7xl">

        {/* Header section */}
        <div className="mb-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <div className="min-w-0">
              <h1 className="text-sm font-semibold tracking-tight text-gray-900 lg:text-base">
                AI Chat Info Overview
              </h1>
              <p className="mt-0.5 text-[11px] text-gray-500">
                Manage titles and descriptions displayed in the site aiChatInfo.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                Items: {hasData ? aiChatInfoList.length : 0}
              </span>
              <span className="hidden md:inline text-[11px] text-gray-500">
                Tip: keep descriptions under ~120 characters.
              </span>
            </div>
          </div>
        </div>

        {/* Table card */}
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="w-full overflow-x-auto">
            <table className="min-w-full table-auto text-left text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="w-1/3 px-4 py-3 font-semibold text-gray-700 border-b border-gray-200">
                    Title
                  </th>
                  <th className="w-1/3 px-4 py-3 font-semibold text-gray-700 border-b border-gray-200">
                    Description
                  </th>
                  <th className="w-1/3 px-4 py-3 text-center font-semibold text-gray-700 border-b border-gray-200">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {aiChatInfo ? (
                  hasData ? (
                    aiChatInfoList.map((ai_info) => (
                      <tr
                        key={ai_info?.ai_chat_info_id}
                        className="transition-colors hover:bg-gray-50"
                      >
                        <td className="px-4 py-3 align-top">
                          {/* inline label */}
                          <div className="text-[11px] uppercase tracking-wide text-gray-500 mb-1">
                            Title
                          </div>
                          <div className="text-gray-900 whitespace-pre-line break-words">
                            {ai_info?.title}
                          </div>
                        </td>
                        <td className="px-4 py-3 align-top">
                          <div className="text-[11px] uppercase tracking-wide text-gray-500 mb-1">
                            Description
                          </div>
                          <div className="text-gray-700 whitespace-pre-line break-words">
                            {ai_info?.description}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <ActionButton props={ai_info} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="px-4 py-8 text-center text-sm text-gray-500" colSpan={3}>
                        No aiChatInfo sections yet.
                      </td>
                    </tr>
                  )
                ) : (
                  // loading state
                  Array.from({ length: 3 }).map((_, i) => (
                    <tr key={i} className="animate-pulse">
                      <td className="px-4 py-3">
                        <div className="h-4 w-40 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="h-4 w-64 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="mx-auto h-9 w-20 rounded-lg bg-gray-200" />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* AiChatInfo helper text */}
        <p className="mt-3 text-[11px] text-gray-500">
          These items appear across the site aiChatInfo. Keep them short and clear.
        </p>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  return (
    <div className="flex flex-row justify-center items-center text-xs">
      <Link to={editRoute}>
        <MyButton
          title="Edit"
          className="rounded-lg bg-blue-600 px-3 py-2 font-semibold shadow-sm transition hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          onClick={() => pushOneAiChatInfo(props)}
        />
      </Link>
    </div>
  );
};

export default Overview;
